import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { CardLayout } from '@modules/card/enums/card-layout.enum';
import { Screen } from '@modules/shared/services/window.service';

import { CardComponent } from '../../card/card/card.component';
import { MediaComponent } from '../../media/media.component';
import { SquareSectionModel } from '../models/square-section.model';
import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-square-section',
  templateUrl: './square-section.component.html',
  styleUrls: ['./square-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CardComponent, MediaComponent],
})
export class SquareSectionComponent extends SectionDefaultsComponent {
  public largeLayouts = {
    [Screen.XXXS]: CardLayout.COLUMN,
    [Screen.XS]: CardLayout.HERO,
  };
  public smallLayout = {
    [Screen.XXXS]: CardLayout.COLUMN,
    [Screen.XS]: CardLayout.ROW,
  };
  @Input() data!: SquareSectionModel;
  @Input() inverted!: boolean;
}
